import { cn } from '@/lib/utils'

// ============================================================================
// ВИД ПОЛЯ — ОДИН НА ПРОЕКТ.
// ----------------------------------------------------------------------------
// Два размера, и только два:
//   field    — обычная форма: 13.5px, отступ 9/11, обводка ink-250, фокус
//              брендовым синим с мягким кольцом. Тот же вид даёт класс .input
//              в globals.css — значения обязаны совпадать.
//   compact  — плотная форма-таблица (сделка, тендер): 13px, меньше отступы,
//              рамка видна всегда и той же толщины, что у field (1px): тонкая
//              hairline на белом окне терялась, и поле не читалось как поле.
// Select, Combobox и Input берут вид отсюда — поэтому соседние
// поля на одном экране не разъезжаются. `field-surface` — метка поля для тёмной
// темы (globals.css): кнопка-поле (Select, дата) красится так же, как <input>.
// ============================================================================

export type FieldVariant = 'field' | 'compact'

const fieldBase =
  'field-surface w-full rounded-[10px] border bg-white px-[11px] py-[9px] text-[13.5px] text-ink-900 placeholder:text-ink-400 transition focus:outline-none focus:ring-[3px] focus:ring-accent-50 disabled:bg-ink-50 disabled:cursor-not-allowed'

const compactBase =
  'field-surface w-full rounded-lg border border-ink-250 bg-white px-2.5 py-1.5 text-[13px] text-ink-900 placeholder:text-ink-400 ' +
  'hover:border-ink-300 focus:border-accent-500 focus:outline-none focus:ring-[3px] focus:ring-accent-50 ' +
  'transition-colors disabled:cursor-not-allowed disabled:bg-ink-50 disabled:opacity-60'

export function fieldClass(hasError?: boolean, variant: FieldVariant = 'field') {
  if (variant === 'compact') {
    return cn(compactBase, hasError && 'border-status-red-text')
  }
  return cn(
    fieldBase,
    hasError
      ? 'border-status-red-text focus:border-status-red-text focus:ring-status-red-bg'
      : 'border-ink-250 hover:border-ink-300 focus:border-accent-500',
  )
}

/** Открытое поле-кнопка выглядит как поле в фокусе. */
export function openFieldClass(_variant?: FieldVariant) {
  return 'border-accent-500 ring-[3px] ring-accent-50'
}

/**
 * Поле в ячейке таблицы — количество, цена, скидка в строке заказа и закупки.
 * Одна ширина и один кегль на все числа строки: прежде количество было 84px
 * полужирным 13.5, скидка — 74px обычным 13, цена — 96px, и поля в одной
 * строке были разного размера. Рамка видна всегда: без неё «1» и «не указана»
 * читались как текст, а не как поле, которое можно поправить.
 */
export const cellInputClass =
  'field-surface w-[96px] rounded-md border border-ink-250 bg-white px-2 py-1 text-right text-[13px] tabular-nums text-ink-900 ' +
  'placeholder:text-ink-400 hover:border-ink-300 focus:border-accent-500 focus:outline-none focus:ring-[3px] focus:ring-accent-50 transition-colors'
